export default function StringArrayConverter(val) {
    if (Array.isArray(val) || !val) {
        return val;
    }
    if (typeof val === "string") {
        return val.split(" ");
    }
}



// WEBPACK FOOTER //
// ./src/Converters/StringArrayConverter.ts